import * as yup from 'yup'

const createNegotiationValidate = yup.object().shape({
    contract_negotiation_title: yup
        .string()
        .required('negotiations.title-required'),
    contract_negotiation_type: yup
        .string()
        .required('negotiations.type-required'),
    contract_negotiation_content: yup
        .string()
        .required('negotiations.content-required'),
    contract_negotiation_status: yup
        .string()
        .required('negotiations.status-required'),
    contract_negotiation_priority: yup
        .string()
        .required('negotiations.priority-required'),
    contract_negotiation_deadline: yup
        .string()
        .required('negotiations.deadline-required'),
    contract_negotiation_assignees: yup
        .array()
        .of(yup.number())
        .required('negotiations.assignees-required'),
    contract_negotiation_stage: yup
        .string()
        .required('negotiations.stage-required'),
    contract_negotiation_notes: yup
        .string()
        .required('negotiations.notes-required'),
    contract_negotiation_value: yup
        .number()
        .required('negotiations.value-required'),
    contract_negotiation_progress: yup
        .number()
        .required('negotiations.progress-required'),
    contract_negotiation_customer_id: yup
        .number()
        .required('negotiations.customer-required'),
    contract_negotiation_customer_journey_id: yup
        .number()
        .required('negotiations.customer-journey-required'),
    contract_negotiation_customer_journey_step: yup.string().nullable(),
})

export default createNegotiationValidate
